import { Common } from '@trimblemaps/trimblemaps-js';

export const DayOfWeek = [
  { key: 'SUNDAY', value: 0, display: 'Sunday' },
  { key: 'MONDAY', value: 1, display: 'Monday' },
  { key: 'TUESDAY', value: 2, display: 'Tuesday' },
  { key: 'WEDNESDAY', value: 3, display: 'Wednesday' },
  { key: 'THURSDAY', value: 4, display: 'Thursday' },
  { key: 'FRIDAY', value: 5, display: 'Friday' },
  { key: 'SATURDAY', value: 6, display: 'Saturday' },
];

export function getDayOfWeek(day: string) {
  let dayOfWeek;
  dayOfWeek = Common.DayOfWeek.SUNDAY;
  if (day === 'monday') {
    dayOfWeek = Common.DayOfWeek.MONDAY;
  } else if (day === 'tuesday') {
    dayOfWeek = Common.DayOfWeek.TUESDAY;
  } else if (day === 'wednesday') {
    dayOfWeek = Common.DayOfWeek.WEDNESDAY;
  } else if (day === 'thursday') {
    dayOfWeek = Common.DayOfWeek.THURSDAY;
  } else if (day === 'friday') {
    dayOfWeek = Common.DayOfWeek.FRIDAY;
  } else if (day === 'saturday') {
    dayOfWeek = Common.DayOfWeek.SATURDAY;
  }
  return dayOfWeek;
}

export function getTimeZone(tz: string) {
  let timeZone;
  timeZone = Common.TimeZone.LOCAL;
  if (tz === 'system') {
    timeZone = Common.TimeZone.SYSTEM;
  }
  if (tz === 'hawaii') {
    timeZone = Common.TimeZone.HAWAII;
  }
  if (tz === 'alaska') {
    timeZone = Common.TimeZone.ALASKA;
  }
  if (tz === 'pacific') {
    timeZone = Common.TimeZone.PACIFIC;
  }
  if (tz === 'arizona') {
    timeZone = Common.TimeZone.ARIZONA;
  }
  if (tz === 'mountain') {
    timeZone = Common.TimeZone.MOUNTAIN;
  }
  if (tz === 'central') {
    timeZone = Common.TimeZone.CENTRAL;
  }
  if (tz === 'eastern') {
    timeZone = Common.TimeZone.EASTERN;
  }
  if (tz === 'atlantic') {
    timeZone = Common.TimeZone.ATLANTIC;
  }
  if (tz === 'newfoundland') {
    timeZone = Common.TimeZone.NEWFOUNDLAND;
  }
  if (tz === 'gmt') {
    timeZone = Common.TimeZone.GMT;
  }
  if (tz === 'utc') {
    timeZone = Common.TimeZone.UTC;
  }
  return timeZone;
}
